
import defaultLanguage from 'common/constants/defaultLanguage';

class LocaleService {

    async init(userLocale) {
        const localesResult = await this.getLocales(); //if we have a non-empty response in time/cached.
        this.locales = localesResult.length ? localesResult : [defaultLanguage];
        if (this.locales.length) {
            return this.getTranslations(userLocale);
        }
    }

    async getLocales() {
        try {
            if (!this.locales || this.locales.length === 0) {
                const response = await fetch(`/i18n/locales.json`);
                const result = await response.json();
                this.locales = result;
            }
            return this.locales;
        } catch (error) {
            console.error('Error in getLocales:', error);
            return undefined;
        }
    }

    getLocaleByCode(code) {
        return this.locales.length > 1
            ? this.locales.find(locale => locale.isoCode == code || locale.cultureLanguageCode == code)
            : this.locales[0];
    }

    getLocaleById(id) {
        return this.locales.length > 1 ? this.locales.find(locale => locale.lcId == id) : this.locales[0];
    }

    getTranslations(lcid) {
        if (lcid) {
            //some locale sources give isoCode "en-ES" (browser lang), other give lcid "en_ES" (our language dropdown), check both just in case
            const currentLocaleData = this.getLocaleById(lcid) ?? this.getLocaleByCode(lcid)
            let translationsUrl = `/i18n/${currentLocaleData.lcId}.json`;
            return fetch(translationsUrl)
                    .then(response => response.json())
                    .then(data => ({
                        ...currentLocaleData,
                        translations: data
                    }));
        } else {
            return Promise.resolve({ translations: {} });
        }
    }

    getBrowserCultureLang() {
        let browserCultureLang = window.navigator.languages ? window.navigator.languages[0] : null;

        browserCultureLang =
            browserCultureLang ||
            window.navigator.language ||
            window.navigator.browserLanguage ||
            window.navigator.userLanguage;

        return browserCultureLang;
    }

    getOrganizationLocales = async id => {
        return await this.apiService.get(`/actions/organization/locales/${id}`);
    };
}

export default new LocaleService();
